import css from './field-label.module.css';
import {Text} from '@web-libs/ui/ui-components/typo/text';
import {useMemo} from 'react';
import {Color} from '@web-libs/features/colors/application/colors';

type FieldLabelProps = {
    label?: string,
    float: boolean,
    error: boolean,
    focused: boolean,
    baseColor: Color,
    focusedColor: Color
}

export const FieldLabel = (props: FieldLabelProps) => {

    const labelColor = useMemo((): Color => {
                                   return props.error ? 'warn' : props.focused ? props.focusedColor : props.baseColor;
                               },
                               [props.focused, props.error, props.baseColor, props.focusedColor]);

    const floatingClassName = props.float && css.floating;
    const className = `${css.label} ${floatingClassName}`;

    return (
        props.label && <label className={className}>
            <Text color={labelColor} size={'md'}>
                {props.label}
            </Text>
        </label>
    );
};
